import React from "react";
import { Modal, Button, Row, Col, Form, Card } from "react-bootstrap";

function ReviewProductonHoldModal({ show, handleClose }) {
    return (
        <Modal show={show} onHide={handleClose} centered size="md" className="font_family">
            <Modal.Body className="p-5">
                <strong className="fs-4">Review Product on Hold</strong>
                {/* Product Information Card */}
                <Card className="mb-4 bg-light border-0 mt-4">
                    <Card.Body>
                        <Row>
                            <h6>Product Information</h6>
                            <Col md={6}>
                                <strong>Name:</strong> Spheribloc
                            </Col>
                            <Col md={6}>
                                <strong>Date:</strong> <span className="fw-semibold">28/04/2025</span>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col md={6}>
                                <strong>Qty:</strong> 05
                            </Col>
                            <Col md={6}>
                                <strong>Nature:</strong> <span className="fw-semibold">Undefined NC</span>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Corrective Measure Dropdown */}
                <Row className="mb-3 align-items-center">
                    <Col md={4}>
                        <Form.Label><strong>Corrective Measure</strong></Form.Label>
                    </Col>
                    <Col md={8}>
                        <Form.Select>
                            <option>Select Measure</option>
                            <option>Rework</option>
                            <option>Scrap</option>
                            <option>Return to Supplier</option>
                        </Form.Select>
                    </Col>
                </Row>

                {/* Measure Effectiveness */}
                <Row className="mb-3 align-items-start">
                    <Col md={4}>
                        <Form.Label><strong>Measure Effectiveness</strong></Form.Label>
                    </Col>
                    <Col md={8}>
                        <Form.Control as="textarea" rows={3} placeholder="Describe effectiveness..." />
                    </Col>
                </Row>

                {/* Accepted & Rejected Quantities */}
                <Row className="mb-3 align-items-center">
                    <Col md={4}>
                        <Form.Label><strong>Quantity Accepted</strong></Form.Label>
                    </Col>
                    <Col md={8}>
                        <Form.Control type="number" />
                    </Col>
                </Row>

                <Row className="mb-4 align-items-center">
                    <Col md={4}>
                        <Form.Label><strong>Quantity Rejected</strong></Form.Label>
                    </Col>
                    <Col md={8}>
                        <Form.Control type="number" />
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer className="border-0 mb-3">
                <Button variant="dark">Submit</Button>
                <Button variant="dark">Create Report</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ReviewProductonHoldModal;
